import React from "react";
import { ChangeEvent, ChangeEventHandler, InputHTMLAttributes } from "react";

interface IDelayInputProps extends InputHTMLAttributes<HTMLInputElement> {
    timeout: number;
    onChangeDelayed?: ChangeEventHandler<HTMLInputElement>;
}

interface IDelayInputState {
    value: string | number | string[];
}

class DelayInput extends React.Component<IDelayInputProps, IDelayInputState> {
    private timeout?: number;

    constructor(props: Readonly<IDelayInputProps>) {
        super(props);

        this.state = {
            value: (props.value || "").toString()
        };

        this.handleChange = this.handleChange.bind(this);
    }

    public componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    public componentDidUpdate(prevProps: Readonly<IDelayInputProps>) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: (this.props.value || "").toString()
            });
        }
    }

    public render() {
        const { timeout, onChange, onChangeDelayed, value, ...props } = this.props;

        return <input onChange={this.handleChange} value={this.state.value} {...props} />
    }

    private handleChange(e: ChangeEvent<HTMLInputElement>) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        const target = e.currentTarget;

        this.setState({
            value: target.value
        });

        // NOTE: [Tyler, 2019-02-28] I'm not sure if cloning the event object like this
        //   is a bad idea or not, but it seems to work alright
        const t: ChangeEvent<HTMLInputElement> = Object.assign({}, e);

        this.timeout = window.setTimeout(() => {
            if (this.props.onChangeDelayed) {
                this.props.onChangeDelayed(t);
            }

            // Reset to last provided state to handle if our changed value is filtered by our parent
            //   If it's filtered, we won't receive an update to change us to the new value, so we'd
            //   keep displaying the old incorrect value.
            // This seems to be fine because any setState on the parent appears to be queued after ours
            this.setState({
                value: (this.props.value as any) || ""
            });
        }, this.props.timeout);

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }
}

export default DelayInput;